module.exports = __webpack_public_path__ + "static/bg-sec8-36f3fc9345c8dbbe3c5ad48f33dec88f.jpg";